import { render, staticRenderFns } from "./game-tabbar.vue?vue&type=template&id=7c2921cf&scoped=true&"
import script from "./game-tabbar.vue?vue&type=script&lang=js&"
export * from "./game-tabbar.vue?vue&type=script&lang=js&"
import style0 from "./game-tabbar.vue?vue&type=style&index=0&id=7c2921cf&prod&lang=css&"
import style1 from "./game-tabbar.vue?vue&type=style&index=1&id=7c2921cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2921cf",
  null
  
)

export default component.exports